import React, { useState, useEffect } from 'react';
import moment from "moment";
import { FuncionarioDados } from '../../../entidades';
import { Alert, Box, Col, Row, StaticField } from '@intech/web-ui';

import { LoadingComponent } from '../../../components/LoadingComponent';

interface IProps {
  dados: FuncionarioDados
}

export const DadosPessoais: React.FC<IProps> = ({
  dados
}) => {

  const [AlertText, setAlertText] = useState<string>("");
  const [Dados, setDados] = useState<FuncionarioDados>();

  useEffect(() => {
    (async () => {
      try {
        setDados(dados);
      }
      catch (e) {
        const error = e.response ? e.response.data : e;
        console.log(error);
        setAlertText(error);
      }

    })();
  }, []);

  function CorrigirData(data: Date | undefined) {
    if (data === undefined)
      return "";
    const Data = moment(data, "DD/MM/yyyy");
    if (Data.isValid())
      return Data.format("DD/MM/yyyy")
    return "";
  }

  function renderDadosPessoais() {
    if (Dados !== undefined) {

      return (
        <Box title={"Dados Pessoais"}>
          <Row>
            <Col>
              <StaticField
                value={Dados.DadosPessoais.NOME_ENTID}
                title={"Nome"}
                labelPosition={"up"}
                inline
              />

            </Col>
          </Row>

          <Row>
            <Col>
              <StaticField
                value={Dados.Empresa.NOME_ENTID}
                title={"Empresa"}
                labelPosition={"up"}
                inline
              />
            </Col>

            <Col>
              <StaticField
                value={Dados.Funcionario.NUM_MATRICULA}
                title={"Matrícula"}
                labelPosition={"up"}
                inline
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <StaticField
                value={Dados.DadosPessoais.DS_SEXO}
                title={"Sexo"}
                labelPosition={"up"}
                inline
              />
            </Col>

            <Col>
              <StaticField
                value={Dados.DS_ESTADO_CIVIL}
                title={"Estado Civil"}
                labelPosition={"up"}
                inline
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <StaticField
                value={Dados.DadosPessoais.NU_IDENT}
                title={"RG"}
                labelPosition={"up"}
                inline
              />
            </Col>

            <Col>
              <StaticField
                value={Dados.DadosPessoais.ORG_EMIS_IDENT}
                title={"Órgão Emissor RG"}
                labelPosition={"up"}
                inline
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <StaticField
                value={CorrigirData(Dados.DadosPessoais.DT_EMIS_IDENT)}
                title={"Emissão RG"}
                labelPosition={"up"}
                inline
              />
            </Col>

            <Col>
              <StaticField
                value={Dados.DadosPessoais.CPF_CGC}
                title={"CPF"}
                labelPosition={"up"}
                inline
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <StaticField
                value={CorrigirData(Dados.DadosPessoais.DT_NASCIMENTO)}
                title={"Data de nascimento"}
                labelPosition={"up"}
                inline
              />
            </Col>

            <Col>
              <StaticField
                value={Dados.IDADE}
                title={"Idade"}
                labelPosition={"up"}
                inline
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <StaticField
                value={CorrigirData(Dados.Funcionario.DT_ADMISSAO)}
                title={"Data de Admissão"}
                labelPosition={"up"}
                inline
              />
            </Col>

            <Col>
              <StaticField
                value={CorrigirData(Dados.Funcionario.DT_RECADASTRO)}
                title={"Data de Recadastramento"}
                labelPosition={"up"}
                inline
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <StaticField
                value={Dados.DadosPessoais.NOME_PAI}
                title={"Nome do Pai"}
                labelPosition={"up"}
                inline
              />
            </Col>

            <Col>
              <StaticField
                value={Dados.DadosPessoais.NOME_MAE}
                title={"Nome da Mãe"}
                labelPosition={"up"}
                inline
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <StaticField
                value={Dados.Entidade.FONE_ENTID}
                title={"Telefone Residencial"}
                labelPosition={"up"}
                inline
              />
            </Col>

            <Col>
              <StaticField
                value={Dados.DadosPessoais.FONE_CELULAR}
                title={"Telefone Celular"}
                labelPosition={"up"}
                inline
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <StaticField
                value={Dados.DadosPessoais.EMAIL_AUX}
                title={"E-mail"}
                labelPosition={"up"}
                inline
              />
            </Col>
          </Row>
        </Box>
      );
    }

    if (AlertText !== "") {
      return (
        <Alert type={"danger"}>
          {AlertText}
        </Alert>
      );
    }

    return <LoadingComponent />;
  }

  return renderDadosPessoais();
}